import { InvoiceSearchRequest, InvoiceGetRequest } from '@trukt/tms-api/InvoiceService';
import { InvoiceIntegrationServiceKeys } from './InvoiceIntegrationServiceKeys';
import { InvoicePaymentServiceKeys } from './InvoicePaymentServiceKeys';
import { createKey } from './createKey';

const keyHandler = createKey('invoice');

export const InvoiceServiceKeys = {
  key: keyHandler.key,
  integration: InvoiceIntegrationServiceKeys,
  payment: InvoicePaymentServiceKeys,
  get: keyHandler.createMethod<InvoiceGetRequest>(),
  search: keyHandler.createMethod<InvoiceSearchRequest>(),
};
